import { NavLink } from 'react-router';

import { cn } from '@/shared/utils/cn';

/** The two halves of «Nóminas»: what came each month, and who receives it. */
export function PayrollTabs() {
  return (
    <nav aria-label="Nóminas" className="border-line flex gap-1 overflow-x-auto border-b">
      {[
        { to: '/nominas', label: 'Meses', end: true },
        { to: '/nominas/trabajadores', label: 'Trabajadores', end: false },
      ].map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.end}
          className={({ isActive }) =>
            cn(
              'shrink-0 border-b-2 px-3 py-2 text-[14px] font-medium whitespace-nowrap',
              isActive ? 'border-accent text-ink' : 'text-ink-3 hover:text-ink border-transparent',
            )
          }
        >
          {tab.label}
        </NavLink>
      ))}
    </nav>
  );
}
